<div [ngClass]=" toggleSidebar ? 'layout-content-spread mt-3':'layout-content-contract mt-3'">
      <div class="sidebar">
            <ng-content select="[leftSidebar]"></ng-content>
      </div>
      <div class="inner-content">
            <ng-content select="[mainContent]"></ng-content>
      </div>
</div>